import { noop } from "@tanstack/react-query"

import { $rqUsersApiClient } from "@/api/users"
import { queryClient } from "@/lib/services/instances"

// 🪄 We will now perform a nasty trick.
// ! HACK: Remove once backend is fixed
export const userSettingsQuery = (() => {
  const q = $rqUsersApiClient.queryOptions("get", "/users/v1/users/settings", undefined, {
    staleTime: Infinity,
    retry: false,
    initialDataUpdatedAt: -Infinity,
    initialData: {}
  })

  // Force a prefetch to ensure the query is available.
  queryClient.query(q).catch(noop)
  return q
})()
